import { RESOURCES_NAMES } from "@/const/resource.constants"
import { TaskAbstract } from "@/organisms/TaskProvider/Task"

import type { Services } from "@/interfaces/services"
import type { Payload, Result } from "./open-pr.types"
export class Task extends TaskAbstract<Payload, Result> {
  constructor(
    protected payload: Payload,
    private props: {
      http: Services.IHttpAdapter
      globalAbortSignal?: AbortSignal
    }
  ) {
    super(payload, props)
  }

  protected async execute() {
    const { issueId, fixId, demo, meta } = this.payload

    // Demo: no real PR is opened; surface the same running -> success UX.
    if (demo) {
      await new Promise((resolve) => setTimeout(resolve, 1200))
      const url = typeof meta?.prUrl === "string" ? meta.prUrl : ""
      return { ok: true, result: { url } }
    }

    try {
      const { ISSUES, ISSUES_GENERATE, ISSUES_APPLY } = RESOURCES_NAMES.TRIAGE
      const requestUrl = `${ISSUES}/${issueId}/${ISSUES_GENERATE}/${fixId}/${ISSUES_APPLY}`
      const { data: result } = await this.props.http.post<{
        data: { url: string }
      }>(requestUrl, { fixId }, { signal: this.props.globalAbortSignal })

      return { ok: true, result }
    } catch (error) {
      return { error, ok: false, result: null }
    }
  }
}
